<template>
  <div class="reading-content">
    <img class="image" :src="src" alt="" />
    <div class="load">
      <img
        class="image"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_reading"
        alt=""
      />
      <div>读取中</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    src: {
      default: ''
    }
  },
  data() {
    return {}
  },
  created() {
    this.uploadImage()
  },
  methods: {
    uploadImage() {}
  }
}
</script>
<style lang="scss" scoped>
.reading-content {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 10;
  background-color: #fff;
  .image {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .load {
    width: 200px;
    height: 200px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 25px;
    text-shadow: 0px 2px 4px #7a0000;
    .image {
      z-index: -1;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      animation: myrotate 4s linear infinite;
    }
  }
}
@keyframes myrotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
